import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation('home');

  return (
    <section className="w-full py-16 md:py-24 px-6 md:px-10 lg:px-16 bg-white">
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
          {t('cta.title')}
          <br />
          {t('cta.titleLine2')}
        </h2>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-gray-500 leading-relaxed">
          {t('cta.description')}
        </p>
        <Link
          to="/artistas"
          className="inline-flex items-center gap-2 mt-6 md:mt-8 px-8 py-4 bg-amber-700 text-white text-sm font-medium rounded-full hover:bg-amber-800 transition-colors whitespace-nowrap"
        >
          {t('cta.button')}
          <i className="ri-arrow-right-line text-sm"></i>
        </Link>
      </div>

      <div className="mt-10 md:mt-14 flex gap-3 md:gap-4 overflow-x-auto pb-2 scrollbar-hide">
        <img
          src="https://readdy.ai/api/search-image?query=concert%20stage%20with%20dramatic%20lighting%20and%20musical%20instruments%2C%20drums%20and%20guitars%20on%20stage%2C%20golden%20amber%20spotlights%2C%20professional%20photography%2C%20dark%20background%20with%20warm%20lights%2C%20Las%20Vegas%20venue%20atmosphere%2C%20high%20quality%20music%20scene&width=300&height=200&seq=29&orientation=landscape"
          alt="Music stage"
          className="w-48 md:w-64 h-32 md:h-44 object-cover rounded-2xl flex-shrink-0"
        />
        <img
          src="https://readdy.ai/api/search-image?query=violin%20and%20cello%20instruments%20on%20elegant%20dark%20background%2C%20professional%20music%20photography%2C%20golden%20amber%20lighting%2C%20luxury%20atmosphere%2C%20close-up%20of%20string%20instruments%2C%20Las%20Vegas%20classical%20music%20style%2C%20warm%20tones&width=300&height=200&seq=30&orientation=landscape"
          alt="String instruments"
          className="w-48 md:w-64 h-32 md:h-44 object-cover rounded-2xl flex-shrink-0"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Las%20Vegas%20neon%20lights%20at%20night%20with%20music%20venue%20signs%2C%20bright%20colorful%20neon%20signs%2C%20dark%20night%20sky%2C%20vibrant%20city%20energy%2C%20professional%20photography%2C%20concert%20venue%20atmosphere%2C%20warm%20golden%20and%20amber%20accents%2C%20high%20quality%20cityscape&width=300&height=200&seq=31&orientation=landscape"
          alt="Las Vegas neon lights"
          className="w-48 md:w-64 h-32 md:h-44 object-cover rounded-2xl flex-shrink-0"
        />
        <img
          src="https://readdy.ai/api/search-image?query=saxophone%20and%20jazz%20instruments%20on%20stage%20with%20warm%20lighting%2C%20professional%20music%20photography%2C%20golden%20amber%20spotlights%2C%20dark%20background%2C%20sophisticated%20jazz%20lounge%20atmosphere%2C%20Las%20Vegas%20style%2C%20elegant%20and%20moody%2C%20high%20quality&width=300&height=200&seq=32&orientation=landscape"
          alt="Jazz instruments"
          className="w-48 md:w-64 h-32 md:h-44 object-cover rounded-2xl flex-shrink-0"
        />
        <img
          src="https://readdy.ai/api/search-image?query=wedding%20reception%20with%20live%20band%20and%20dancing%20guests%2C%20warm%20candlelight%2C%20elegant%20venue%2C%20romantic%20atmosphere%2C%20professional%20photography%2C%20dark%20background%20with%20golden%20bokeh%2C%20Las%20Vegas%20luxury%20wedding%2C%20celebration%20mood&width=300&height=200&seq=33&orientation=landscape"
          alt="Wedding reception with music"
          className="w-48 md:w-64 h-32 md:h-44 object-cover rounded-2xl flex-shrink-0"
        />
      </div>
    </section>
  );
}